import { Clock } from "lucide-react";
import { useEffect, useState } from "react";

interface UrgencyBannerProps {
  className?: string;
}

export const UrgencyBanner = ({ className = "" }: UrgencyBannerProps) => {
  const [remaining, setRemaining] = useState(47);

  useEffect(() => {
    // Simuliere abnehmende Verfügbarkeit
    const interval = setInterval(() => {
      setRemaining(prev => Math.max(12, prev - 1));
    }, 120000); // Alle 2 Minuten -1

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`bg-destructive/10 border-l-4 border-destructive px-4 py-3 rounded-r-lg mb-6 ${className}`}>
      <div className="flex items-center gap-3">
        <Clock className="w-5 h-5 text-destructive flex-shrink-0" />
        <p className="text-sm font-semibold">
          <span className="text-destructive">Limitiert:</span>
          <span className="text-foreground ml-2">Noch {remaining} Downloads heute verfügbar</span>
        </p>
      </div>
    </div>
  );
};
